import * as React from "react";
import { createPortal } from 'react-dom'

export const Frame = ({ children, ...props }) => {
    
    const [iframeBody, setIframeBody] = React.useState(null);
    const [iframeHead, setIframeHead] = React.useState(null);
    const handleLoad = e => {
      if (e.target.contentDocument) {
          setIframeBody(e.target.contentDocument.body);
          setIframeHead(e.target.contentDocument.head);
        }
    }

    return (
        <iframe srcDoc={`<!DOCTYPE html>`} {...props} onLoad={handleLoad} >
            {iframeHead && createPortal(children[0], iframeHead)}
            {iframeHead && createPortal(children[1], iframeHead)}
            {iframeHead && createPortal(children[2], iframeHead)}
            {iframeBody && createPortal(children[3], iframeBody)}
        </iframe>
    )
}